module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.07088b43.png";